import fetchDesigners from "../helpers/fetchDesigners";

const styles = `
  button {
    display: flex;
    align-items: center;
    gap: var(--gap, 8px);
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;
    font: inherit;
    text-transform: inherit;
    color: inherit;
  }

  .visually-hidden {
    position: absolute !important;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  }
`;

const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(styles);

const content = {
  default: {
    following: () => `
      <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.500004 0.916992C0.367503 0.916992 0.240002 0.970117 0.146254 1.06499C0.052507 1.15985 0 1.28887 0 1.42294V14.5776C0 14.7819 0.121876 14.9665 0.308122 15.045C0.494369 15.1234 0.709379 15.0804 0.8525 14.9362L5 10.7399L9.1475 14.9362C9.29062 15.0804 9.50562 15.1234 9.69188 15.045C9.87813 14.9665 10 14.7819 10 14.5776V1.42294C10 1.28886 9.9475 1.15985 9.85375 1.06499C9.75999 0.970123 9.63249 0.916992 9.5 0.916992H0.500004Z" fill="currentColor"/>
      </svg>
      <span>Following Designer</span>`,
    follow: () => `<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.500004 0.916992C0.367503 0.916992 0.240002 0.970117 0.146254 1.06499C0.052507 1.15985 0 1.28887 0 1.42294V14.5776C0 14.7819 0.121876 14.9665 0.308122 15.045C0.494369 15.1234 0.709379 15.0804 0.8525 14.9362L5 10.7399L9.1475 14.9362C9.29062 15.0804 9.50562 15.1234 9.69188 15.045C9.87813 14.9665 10 14.7819 10 14.5776V1.42294C10 1.28886 9.9475 1.15985 9.85375 1.06499C9.75999 0.970123 9.63249 0.916992 9.5 0.916992H0.500004ZM1.00001 1.92889H9.0014V13.3583L5.35444 9.66611C5.26069 9.57061 5.13319 9.51749 5.00007 9.51749C4.86695 9.51749 4.73944 9.57061 4.64569 9.66611L1.00073 13.3564L1.00001 1.92889Z" fill="currentColor"/>
    </svg>
    <span>Follow Designer</span>`,
  },
  flag: {
    following: ({ designerName = 'Designer' }) => `
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.500004 0.916992C0.367503 0.916992 0.240002 0.970117 0.146254 1.06499C0.052507 1.15985 0 1.28887 0 1.42294V14.5776C0 14.7819 0.121876 14.9665 0.308122 15.045C0.494369 15.1234 0.709379 15.0804 0.8525 14.9362L5 10.7399L9.1475 14.9362C9.29062 15.0804 9.50562 15.1234 9.69188 15.045C9.87813 14.9665 10 14.7819 10 14.5776V1.42294C10 1.28886 9.9475 1.15985 9.85375 1.06499C9.75999 0.970123 9.63249 0.916992 9.5 0.916992H0.500004Z" fill="currentColor"/>
    </svg>
    <span class="visually-hidden">Following ${designerName}</span>`,
    follow: ({ designerName = 'Designer' }) => `
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.500004 0.916992C0.367503 0.916992 0.240002 0.970117 0.146254 1.06499C0.052507 1.15985 0 1.28887 0 1.42294V14.5776C0 14.7819 0.121876 14.9665 0.308122 15.045C0.494369 15.1234 0.709379 15.0804 0.8525 14.9362L5 10.7399L9.1475 14.9362C9.29062 15.0804 9.50562 15.1234 9.69188 15.045C9.87813 14.9665 10 14.7819 10 14.5776V1.42294C10 1.28886 9.9475 1.15985 9.85375 1.06499C9.75999 0.970123 9.63249 0.916992 9.5 0.916992H0.500004ZM1.00001 1.92889H9.0014V13.3583L5.35444 9.66611C5.26069 9.57061 5.13319 9.51749 5.00007 9.51749C4.86695 9.51749 4.73944 9.57061 4.64569 9.66611L1.00073 13.3564L1.00001 1.92889Z" fill="currentColor"/>
    </svg>
    <span class="visually-hidden">Follow ${designerName}</span>`,
  }
}

class FollowDesigner extends HTMLElement {
  static observedAttributes = ['designer-collection-handle'];

  constructor() {
    super();
    this.initialized = false;

    this.shadow = this.attachShadow({ mode: "open" });
    this.shadow.adoptedStyleSheets = [styleSheet];

    const button = document.createElement('button');
    button.type = 'button';
    this.shadow.appendChild(button);

    this.button = this.shadow.querySelector('button');

    this.toggleFollow = (follow) => {
      const action = follow ? 'add' : 'remove';

      window.updateDesigners[action](this.designer.handle)
        .finally(() => { this.button.disabled = false });

      this.isFollowing = follow;
      // Update state immediately instead of waiting for requests to finish,
      // but disable button
      this.state = this.isFollowing ? 'following' : 'follow';
      this.button.disabled = true;
    };

    this.button.addEventListener('click', () => {
      if (!this.initialized) return;

      if (this.showLogin) {
        this.dispatchEvent(new CustomEvent('login-modal:open', { bubbles: true }));
        return;
      }

      this.toggleFollow(!this.isFollowing);
    });

    this.handleFollowDesignersUpdated = () => {
      if (!this.initialized) return;

      window.updateDesigners.has(this.designer.handle)
        .then((isFollowing) => {
          this.isFollowing = isFollowing;
          this.state = isFollowing ? 'following' : 'follow';
        });
    };
  }

  connectedCallback() {
    fetchDesigners()
      .then(designers => {
        const designerCollectionHandle = this.getAttribute('designer-collection-handle');

        this.designer = designers.find((designer) => designer.collection?.handle === designerCollectionHandle);
        if (!this.designer) {
          console.warn('could not find designer for collection', designerCollectionHandle);
          this.style.display = 'none';

          return Promise.resolve(null);
        }

        return window.updateDesigners.has(this.designer.handle);
      })
      .then((isFollowing) => {
        this.initialized = true;

        if (!isFollowing && this.autoFollow) {
          this.toggleFollow(true);
        } else {
          this.isFollowing = isFollowing;
          this.state = isFollowing ? 'following' : 'follow';
        }
      });

    document.addEventListener('follow-designers:updated', this.handleFollowDesignersUpdated);
  }

  disconnectedCallback() {
    document.removeEventListener('follow-designers:updated', this.handleFollowDesignersUpdated);
  }

  set state(newState) {
    this.setAttribute('current-state', newState);
    this.button.innerHTML = content[this.layout][newState]({ designerName: this.designerName });
  }

  get autoFollow() {
    const url = new URL(window.location);
    return url.searchParams.has('follow');
  }

  get designerName() {
    return this.getAttribute('designer-name');
  }

  get layout() {
    const layout = this.getAttribute('element-layout');

    return layout in content ? layout : 'default';
  }

  get showLogin() {
    return this.hasAttribute('show-login');
  }
}

if (!customElements.get("follow-designer")) {
  customElements.define("follow-designer", FollowDesigner);
}
